import * as plugins from './smarttime.plugins.js';

/**
 * one start() of an Interval: its pending wait and the signal stop() resolves
 */
interface IIntervalRun {
  timeout: plugins.smartpromise.Timeout<void> | null;
  stopped: plugins.smartpromise.Deferred<void>;
}

export class Interval {
  public status: 'started' | 'stopped' | 'initial' = 'initial';

  /**
   * the run started last; a loop only iterates while it owns the current run
   */
  private currentRun: IIntervalRun | null = null;

  // timings
  public intervalMilliseconds: number;
  public nextIntervalMillisenconds: number | undefined;

  public intervalJobs: Array<() => any> = [];
  constructor(intervalMillisencondsArg: number) {
    this.intervalMilliseconds = intervalMillisencondsArg;
  }

  public start() {
    this.endCurrentRun();
    this.status = 'started';
    const run: IIntervalRun = {
      timeout: null,
      stopped: plugins.smartpromise.defer<void>(),
    };
    this.currentRun = run;
    const runInterval = async () => {
      while (this.currentRun === run) {
        run.timeout = new plugins.smartpromise.Timeout<void>(this.intervalMilliseconds);
        await Promise.race([run.timeout.promise, run.stopped.promise]);
        if (this.currentRun !== run) {
          break;
        }
        this.executeIntervalJobs();
      }
    };
    runInterval();
  }

  public stop() {
    this.status = 'stopped';
    this.endCurrentRun();
  }

  public addIntervalJob(funcArg: () => any) {
    this.intervalJobs.push(funcArg);
  }

  /**
   * cancels the pending wait of the current run and lets its loop exit
   */
  private endCurrentRun() {
    const run = this.currentRun;
    if (!run) {
      return;
    }
    this.currentRun = null;
    run.timeout?.cancel();
    run.stopped.resolve();
  }

  private executeIntervalJobs() {
    for (const funcArg of this.intervalJobs) {
      funcArg();
    }
  }
}
